'use client';

import {
  CatButton,
  CatHeading,
  CatIconArrowBack,
  CatIconEdit
} from 'components/blocks-components';
import { MyEquipmentList } from 'components/my-equipment/types';
import { CreateListModal } from 'components/saved-lists/create-list-modal';
import { useCreateListModal } from 'providers/create-list-modal-provider';
import styles from '../saved-list-drawer.module.scss';
import cx from 'classnames';

export const SavedListDrawerHeader = ({
  onClose,
  title,
  hideBackButton,
  showCreateListBtn,
  openButtonText,
  isDealerUser,
  isInstantAccessUser,
  isAssociateEquipmentToSavedList,
  isCspUser,
  myEquipmentList,
  selectedEquipmentIndex,
  isError,
  createAction,
  withMobileFixedActions
}: Readonly<{
  onClose: () => void;
  title: string;
  hideBackButton: boolean;
  showCreateListBtn?: boolean;
  openButtonText: string;
  isDealerUser: boolean;
  isInstantAccessUser: boolean;
  isAssociateEquipmentToSavedList: boolean;
  isCspUser: boolean;
  myEquipmentList: MyEquipmentList[];
  selectedEquipmentIndex: number;
  isError: boolean;
  createAction;
  withMobileFixedActions?: boolean;
}>) => {
  const { openModal } = useCreateListModal() || {};
  const handleCreatListClick = () => {
    openModal();
  };
  return (
    <div slot="header" className="d-flex  w-100  align-items-center">
      {!hideBackButton && (
        <CatButton
          hideText
          onClick={onClose}
          variant="ghost"
          className="mr-3"
          data-testid="go-back-button"
        >
          <CatIconArrowBack slot="before" />
        </CatButton>
      )}

      <div className="d-none d-md-block">
        <CatHeading variant="title">{title}</CatHeading>
      </div>

      <div className="d-block d-md-none">
        <CatHeading variant="title-sm">{title}</CatHeading>
      </div>

      {showCreateListBtn && !withMobileFixedActions && (
        <div className={cx('d-md-none ms-auto', styles['edit-savelisticon'])}>
          <CatIconEdit onClick={() => handleCreatListClick()} />
        </div>
      )}
      {(showCreateListBtn || withMobileFixedActions) && (
        <div className="d-none d-md-block ms-auto">
          <CreateListModal
            createAction={createAction}
            isCspUser={false}
            isDealerUser={isDealerUser}
            isInstantAccessUser={isInstantAccessUser}
            isAssociateEquipmentToSavedList={isAssociateEquipmentToSavedList}
            openButtonText={openButtonText}
            openButtonVariant={'contrast'}
            myEquipmentList={myEquipmentList}
            selectedEquipmentIndex={selectedEquipmentIndex}
            isError={isError}
          />
        </div>
      )}
    </div>
  );
};
